export default function AnimatedBackground() {
  const lightSourceStyle = {
    position: "absolute",
    width: "80vw",
    height: "80vh",
    borderRadius: "50%",
    filter: "blur(120px)",
    mixBlendMode: "plus-lighter", // This creates that clean, professional glow
    opacity: 0.15,
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        background:
          "radial-gradient(circle at center, #1a1a3e 0%, #0a0e27 100%)", // A very dark navy-black
        overflow: "hidden",
      }}
    >
      {/* --- SOFT LIGHT SOURCES --- */}

      {/* Main Teal Glow */}
      <div
        style={{
          ...lightSourceStyle,
          background: "radial-gradient(circle, #c8d606 0%, transparent 70%)",
          top: "-10%",
          left: "-10%",
          animation: "drift 25s ease-in-out infinite alternate",
        }}
      />

      {/* Deep Purple Glow */}
      <div
        style={{
          ...lightSourceStyle,
          background: "radial-gradient(circle, #8338EC 0%, transparent 70%)",
          bottom: "-20%",
          right: "-10%",
          animation: "drift 30s ease-in-out infinite alternate-reverse",
        }}
      />

      {/* Soft Blue Center Glow */}
      <div
        style={{
          ...lightSourceStyle,
          width: "100vw",
          background: "radial-gradient(circle, #ff0000 0%, transparent 60%)",
          top: "20%",
          left: "10%",
          opacity: 0.1,
          animation: "pulse 15s ease-in-out infinite",
        }}
      />

      {/* --- TEXTURE & GLASS --- */}

      {/* Subtle Grain Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.05,
          pointerEvents: "none",
          zIndex: 1,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.6' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* The "Frosted" Glass Layer */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(100px) saturate(150%)",
          background: "rgba(10, 11, 16, 0.2)",
          zIndex: 2,
        }}
      />

      <style>{`
        @keyframes drift {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(10vw, 5vh) scale(1.1); }
          100% { transform: translate(-5vw, -10vh) scale(1); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.15; }
        }
      `}</style>
    </div>
  );
}
